import { ReactNode } from 'react'
import { Category, CategoryProps } from './category'
import styles from './templates.module.css'

interface WrapperProps extends CategoryProps {
  children: ReactNode
  id?: string
  className?: string
}

export function Wrapper({
  categories,
  selectedCategory,
  children,
  id = 'template-list',
  className = ''
}: WrapperProps): JSX.Element {
  return (
    <section
      id={id}
      className={`${styles.library} ${className}`}
      aria-label="Browse templates"
    >
      <div className={`${styles.container} ${styles.libraryLayout}`}>
        <Category categories={categories} selectedCategory={selectedCategory} />
        <div className={styles.results}>{children}</div>
      </div>
    </section>
  )
}
